import React, { useEffect,useState } from "react";
import SuccessPopUp from "components/SuccessPopUp";
import { Image } from "react-bootstrap";
import { useSelector,useDispatch } from "react-redux";
import "../../pages/InvalidRoute/index.scss";
import Signdesk_logo from "assets/images/signdesk_logo.svg";
import { useLocation } from "react-router-dom";
import LinkExpiry from "components/LinkExpiry";
import { getOrgInfo } from "api/organisation";
import { Container,Row,Col,Nav,Navbar } from "react-bootstrap";
import { setAppColor } from "helper";


const ErrorPage = () => {
  const { state } = useLocation();
  // const dispatch = useDispatch()
  const applicantUser = useSelector((state) => state?.userInfo?.applicantUser);
  // const logoUrl = useSelector((state) => state.urlEncryption?.logoUrl);
  
  const organisation_id = useSelector(
    (state) => state?.loggedInUserInfo
  ).organisation_id;
  let [logoUrl, setLogoURL] = useState();
  const [poweredBy, setPoweredBy] = useState(false);
  const layoutSetting = useSelector((state)=> state?.loggedInUserInfo?.userAuthInfo?.organisationInfo?.layout_setting)
  setAppColor(layoutSetting)
  
  useEffect(() => {
      getOrgInfo({ _id: organisation_id }).then((res) => {
        setPoweredBy(res?.white_labeled ? res?.white_labeled : false);
        if (res?.logo) {
          setLogoURL('https://signdesk.in/company/' + res?.logo)
          const list = document.getElementById('favicon_customized');
          // list.href = '/unified/' + (res?.fav_icon ? res?.fav_icon : 'signdesk_logo@2x.png');
          list.href = res?.icon ? `https://signdesk.in/company/${res?.icon}` : 'https://signdesk.com/images/favicon.png';
          const titleName = document.getElementById('title-id');
          titleName.innerText = res?.setting?.parent_client_name;
        } else {
          setLogoURL("https://signdesk.in/company/signDesk-logo.png")
          const list = document.getElementById('favicon_customized');
          list.href = '/unified/signdesk_logo@2x.png';
          const titleName = document.getElementById('title-id');
          titleName.innerText = 'Signdesk';
        }

      })
  }, [organisation_id])

  return (
    <>
    {/* <div className="layoutContainer">
      <div className="mainLogo">
        <Image src={logoUrl} className="client-logo" />
      </div>

      <div className="signdesk_logo">
        <p>Powered by</p>
        <Image src={Signdesk_logo} alt="signDesk_logo" />
      </div>
    </div> */}
      <div className="bg-forms-two vh-100 bg-no-repeat bg-cover position-relative">
      <Navbar expand="lg" className="bg-body-tertiary bg-forms-two bg-cover bg-sm-white">
      <Container fluid>
        <Navbar.Brand href="#home">
        <Image src={logoUrl} className="client-logo" />
        </Navbar.Brand>
      </Container>
    </Navbar>
    <Container>
      <Row className="error-container-height align-items-center justify-content-center">
      {state?.isLinkExpired ? (
        <LinkExpiry
        header = {state?.header}
        content = {state?.body}
        />
      ) : (
        <SuccessPopUp
          className="cardcontainer_style"
          header={
            state?.header ? state?.header : "401 Error: Unauthorized Access"
          }
          content={
            state?.body
              ? state?.body
              : `It looks like you don't have the valid authentication credentials to view this page.`
          }
        />
      )}
      </Row>
    </Container>
    {poweredBy && (
      <div className="d-flex position-absolute bottom-0 end-0 pb-2 pe-3">
        <p className="m-0 fs-13px me-2">Powered by</p>
          <Image src={Signdesk_logo} alt="signDesk_logo" />
      </div>
    )}
    </div>
    </>
  );
};

export default ErrorPage;
